var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDirection(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 319.148,
    x2: 380.148,
    y1: 102.763,
    y2: 199.763
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#ffcd3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#ffad2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa325"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c0272d"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 369.038,
    x2: 459.038,
    xlinkHref: "#lg1",
    y1: 153.599,
    y2: -32.401
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 280.743,
    x2: 321.964,
    y1: 255.742,
    y2: 321.29
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cdec7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2157,
    stopColor: "#b0e995"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5613,
    stopColor: "#87e4bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8347,
    stopColor: "#6ee1d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65e0db"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cdec7a",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2354,
    stopColor: "#9ad57d",
    stopOpacity: 0.235
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6035,
    stopColor: "#51b482",
    stopOpacity: 0.604
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8679,
    stopColor: "#239f85",
    stopOpacity: 0.868
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#119786"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 293.637,
    x2: 350.069,
    xlinkHref: "#lg2",
    y1: 333.748,
    y2: 217.121
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 348.909,
    x2: 212.409,
    xlinkHref: "#lg1",
    y1: 180.319,
    y2: 141.319
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 356.034,
    x2: 197.034,
    xlinkHref: "#lg2",
    y1: 331.428,
    y2: 255.428
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8f6fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#efdcfb"
  }))), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 230.145,
    x2: 285.723,
    xlinkHref: "#lg3",
    y1: 263.576,
    y2: 263.576
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#efdcfb",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0287,
    stopColor: "#e9d6f7",
    stopOpacity: 0.029
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2203,
    stopColor: "#c5b5de",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4138,
    stopColor: "#aa9bcb",
    stopOpacity: 0.414
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6078,
    stopColor: "#9688bd",
    stopOpacity: 0.608
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8028,
    stopColor: "#8a7db5",
    stopOpacity: 0.803
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8679b2"
  }))), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 267.66,
    x2: 238.16,
    xlinkHref: "#lg4",
    y1: 132.559,
    y2: 12.559
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 241.789,
    x2: 268.455,
    xlinkHref: "#lg3",
    y1: 21.419,
    y2: 63.419
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 249.031,
    x2: 262.364,
    xlinkHref: "#lg3",
    y1: 64.023,
    y2: 99.689
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    y1: 460.528,
    y2: 517.866
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8a7889"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3344,
    stopColor: "#867385"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#7b667b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6e566e"
  }))), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 295.764,
    x2: 166.307,
    xlinkHref: "#lg4",
    y1: 309.103,
    y2: 190.102
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 121.619,
    x2: 176.619,
    y1: 175.873,
    y2: 309.873
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffa936"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4112,
    stopColor: "#ff8548"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7781,
    stopColor: "#ff6c54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff6359"
  }))), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 147.842,
    x2: 91.842,
    xlinkHref: "#lg1",
    y1: 258.316,
    y2: 91.316
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m426.521 204.433h-159.596c-6.586 0-11.925-5.339-11.925-11.925v-64.726c0-6.586 5.339-11.925 11.925-11.925h159.596c7.347 0 14.391 2.931 19.569 8.143l23.573 23.727c6.826 6.871 6.826 17.964 0 24.835l-23.573 23.728c-5.178 5.212-12.222 8.143-19.569 8.143z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255 192.508c0 6.586 5.339 11.925 11.925 11.925h159.596c7.347 0 14.391-2.931 19.569-8.143l23.573-23.727c3.413-3.436 5.12-7.927 5.12-12.418h-219.783z",
    fill: "url(#SVGID_2_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m343.967 332.086h-82.781c-3.416 0-6.186-4.711-6.186-10.522v-57.109c0-5.811 2.769-10.522 6.186-10.522h82.781c3.811 0 7.464 2.586 10.15 7.185l12.227 20.935c3.541 6.063 3.541 15.85 0 21.913l-12.227 20.935c-2.686 4.598-6.339 7.185-10.15 7.185z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255 321.564c0 5.811 2.769 10.522 6.186 10.522h82.781c3.811 0 7.464-2.586 10.15-7.185l12.227-20.935c1.77-3.031 2.656-6.994 2.656-10.956h-114z",
    fill: "url(#SVGID_4_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m291.357 115.857h-24.431c-6.586 0-11.925 5.339-11.925 11.925v64.726c0 6.586 5.339 11.925 11.925 11.925h113.008z",
    fill: "url(#SVGID_5_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m261.186 332.086h82.781c3.811 0 7.464-2.586 10.15-7.185l2.552-4.369-65.532-65.532s-.053-.374-.15-1.067h-29.802c-3.416 0-6.186 4.711-6.186 10.522v57.109c.001 5.811 2.77 10.522 6.187 10.522z",
    fill: "url(#SVGID_6_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m218.863 65.549h72.274v396.055h-72.274z",
    fill: "url(#SVGID_7_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m291.137 65.549h-72.274v31.024l72.274 72.274z",
    fill: "url(#SVGID_8_)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 42.227,
    fill: "url(#SVGID_9_)",
    r: 42.227
  }), /*#__PURE__*/React.createElement("path", {
    d: "m284.931 98h-59.862c-7.836 0-14.189-6.353-14.189-14.189v-7.643c0-7.836 6.353-14.189 14.189-14.189h59.862c7.836 0 14.189 6.353 14.189 14.189v7.643c0 7.836-6.353 14.189-14.189 14.189z",
    fill: "url(#SVGID_10_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m374.525 510h-239.05c-8.607 0-15.021-7.938-13.214-16.353 4.387-20.434 22.449-35.03 43.349-35.03h178.78c20.9 0 38.962 14.596 43.349 35.03 1.807 8.415-4.607 16.353-13.214 16.353z",
    fill: "url(#SVGID_11_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m291.137 247.688-38.697-38.697c-2.184-2.772-5.563-3.559-9.366-3.559h-24.212v87.576l72.274 72.274v-117.594z",
    fill: "url(#SVGID_12_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m83.479 293.009h159.596c6.586 0 11.925-5.339 11.925-11.925v-64.726c0-6.586-5.339-11.925-11.925-11.925h-159.596c-7.347 0-14.391 2.931-19.569 8.143l-23.573 23.727c-6.826 6.871-6.826 17.964 0 24.835l23.573 23.727c5.178 5.213 12.222 8.144 19.569 8.144z",
    fill: "url(#SVGID_13_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255 281.084c0 6.586-5.339 11.925-11.925 11.925h-159.596c-7.347 0-14.391-2.931-19.569-8.143l-23.573-23.727c-3.413-3.436-5.12-7.927-5.12-12.418h219.783z",
    fill: "url(#SVGID_14_)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDirection);
export default __webpack_public_path__ + "static/media/icon-direction.9804c6967038d355491fc3d056f659b1.svg";
export { ForwardRef as ReactComponent };